import React from "react";
import "./service.scss";
function Service() {
  return (
    <div data-scroll-section="" className="service">
      <div className="container px-5 mx-auto text-center">
        <h2 className="">
          <div
            className="inline-block"
            data-scroll=""
            data-scroll-delay="0.15"
            data-scroll-speed="3"
          >
            R
          </div>
          <div
            className="inline-block"
            data-scroll=""
            data-scroll-delay="0.095"
            data-scroll-speed="3"
          >
            e
          </div>
          <div
            className="inline-block"
            data-scroll=""
            data-scroll-delay="0.085"
            data-scroll-speed="3"
          >
            c
          </div>
          <div
            className="inline-block"
            data-scroll=""
            data-scroll-delay="0.075"
            data-scroll-speed="3"
          >
            e
          </div>
          <div
            className="inline-block"
            data-scroll=""
            data-scroll-delay="0.065"
            data-scroll-speed="3"
          >
            n
          </div>
          <div
            className="inline-block"
            data-scroll=""
            data-scroll-delay="0.055"
            data-scroll-speed="3"
          >
            t
          </div>
          <div
            className="inline-block"
            data-scroll=""
            data-scroll-delay="0.045"
            data-scroll-speed="3"
          >
            {" "}
          </div>
          <div
            className="inline-block"
            data-scroll=""
            data-scroll-delay="0.043"
            data-scroll-speed="3"
          >
            p
          </div>
          <div
            className="inline-block"
            data-scroll=""
            data-scroll-delay="0.035"
            data-scroll-speed="3"
          >
            r
          </div>
          <div
            className="inline-block"
            data-scroll=""
            data-scroll-delay="0.045"
            data-scroll-speed="3"
          >
            o
          </div>
          <div
            className="inline-block"
            data-scroll=""
            data-scroll-delay="0.055"
            data-scroll-speed="3"
          >
            j
          </div>
          <div
            className="inline-block"
            data-scroll=""
            data-scroll-delay="0.065"
            data-scroll-speed="3"
          >
            e
          </div>
          <div
            className="inline-block"
            data-scroll=""
            data-scroll-delay="0.075"
            data-scroll-speed="3"
          >
            c
          </div>
          <div
            className="inline-block"
            data-scroll=""
            data-scroll-delay="0.085"
            data-scroll-speed="3"
          >
            t
          </div>
          <div
            className="inline-block"
            data-scroll=""
            data-scroll-delay="0.095"
            data-scroll-speed="3"
          >
            s
          </div>
          <div
            className="inline-block"
            data-scroll=""
            data-scroll-delay="0.15"
            data-scroll-speed="3"
          >
            .
          </div>
        </h2>
      </div>
    </div>
  );
}

export default Service;
